<template>
<div class="ErrorReport center-xs">
  <img src="https://gosnappy.io/giftcard/img/snappyLogo.png" alt="Favicon">

  <h1>
    {{ $vuetify.lang.t('$vuetify.errorReport.main') }}
  </h1>
  <h2>
    {{ $vuetify.lang.t('$vuetify.errorReport.secondary') }}
  </h2>

  <br>

  <h3 class="error--text">
    {{message}}
  </h3>
</div>
</template>

<script>
export default {
  props: ['message'],
}
</script>

<style scoped>
  .ErrorReport {
    height: 500px;
    width: 500px;

    margin: 100px auto;
  }

  img {
    border-radius: 50%;
    border: 0.5px silver solid;

    max-height: 200px !important;
    max-width: 200px !important;
  }

  h1 {
    margin: 30px auto 0px;
  }
</style>
